import React from "react"
import { useStaticQuery, graphql, Link } from "gatsby"
import { IoIosArrowForward } from "react-icons/io"
import Img from "gatsby-image"

import Target from "./Cursor/target";

import "../styles/dribble-shots.scss";

const DribbleShots = () => {
  const query = useStaticQuery(graphql`
    query {
      allDribbbleShot(sort: {fields: [published], order: DESC}, limit: 3) {
        nodes {
          title
          id
          published(formatString: "MMMM DD, YYYY")
          url
          tags
          cover
          localCover {
            childImageSharp {
              fluid(maxWidth: 396) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      }
    }
  `);

  return (
    <div className="hp-dribbleShotsContainer">
      <div className="hp-container hp-column">
        <h2>Dribble Shots</h2>
        <div className="hp-dribbleGrid">
          <div className="dribble_item dribble1">
            <Img fluid={query.allDribbbleShot.nodes[0].localCover.childImageSharp.fluid} />
          </div>
          <div className="dribble_item dribble2">
            <Img fluid={query.allDribbbleShot.nodes[1].localCover.childImageSharp.fluid} />
          </div>
          <div className="dribble_item dribble3">
            <Img fluid={query.allDribbbleShot.nodes[2].localCover.childImageSharp.fluid} />
          </div>
          <div className="hp-dribblemore">
            <Target>
              <Link to="https://dribbble.com/tkhariprasath" target="_blank" className="moreDribbleLink">
                <h5>More dribble shots</h5>
                <IoIosArrowForward size={20} className="arrow" />
              </Link>
            </Target>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DribbleShots
